// extracted by mini-css-extract-plugin
export default {"container":"egMlWC","srOnly":"k3W6L0"};